import Animated, { FadeIn, FadeOut } from "react-native-reanimated";

import NoriConversation from "@/conversation/NoriConversation";

type ConvoWrapperProps = {
  conversationId: string;
};

export default function NoriConvoWrapper({
  conversationId,
}: ConvoWrapperProps) {
  return (
    <Animated.View
      style={{ flex: 1 }}
      entering={FadeIn.duration(150)}
      exiting={FadeOut.duration(150)}
    >
      {conversationId && <NoriConversation conversationId={conversationId} />}
    </Animated.View>
  );
}
